<template>
  <div class="form-group" :class="{ '-error': error }">
    <div class="input">
      <input id="dealername" type="text" :class="{ '-filled': value }" ref="input" :placeholder="placeholder" v-model="value">
      <div class="input-background">
        <label for="dealername">{{ label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
/* global ktgdealersearch */

export default {
  name: 'KtgdealersearchAutocomplete',
  data () {
    return {
      autocomplete: ktgdealersearch.autocomplete
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    dealername: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    value: {
      get () {
        return this.dealername
      },
      set (value) {
        this.$emit('update:dealername', value)
      }
    }
  },
  methods: {
    reset () {
      this.value = ''
      this.autocomplete.reset()
    }
  },
  mounted () {
    const self = this
    self.autocomplete.init(self.$refs.input)
    self.autocomplete.addEventListener('prediction_selected', () => {
      self.$emit('predictionSelected', self.autocomplete.selected)
    })
    self.autocomplete.addEventListener('prediction_submit', () => {
      self.$emit('predictionSubmit', self.value)
    })
  }
}
</script>
